/* eslint-disable no-console */
import {Button, Flex} from 'antd';
import React, {useState} from 'react';

import {ReactComponent as Copilot} from '../../assets/copliot.svg';
import useUserStore from '../../store/userStore/userStore';
import {shouldBlockFreeOrTrial} from '../../utils/SubscriptionHelper';
import CopilotDrawer from '../ControlCenter/CopilotDrawer';
import UpgradeButton from '../UpgradeButton/UpgradeButton';

import ControlCenterMenu from './Utils/ControlCenterMenu';

const MainHeader: React.FC<{
  setProduct: React.Dispatch<React.SetStateAction<string>>;
  product: string;
}> = ({setProduct, product}) => {
  const userDetail = useUserStore((state) => state.userDetails);
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  return (
    <Flex
      justify="space-between"
      className="mainHeader"
      style={{height: '100%'}}
    >
      <div className="headerData">{`Welcome ${
        userDetail?.firstName ?? ''
      }!`}</div>
      <Flex gap={20} style={{height: '100%', alignItems: 'center'}}>
        {shouldBlockFreeOrTrial() ? (
          <UpgradeButton title="Copilot" />
        ) : (
          <Button
            onClick={() => {
              setShowDrawer(true);
            }}
            style={{border: '1px solid #719A5D'}}
          >
            <Flex align="center" gap={10} style={{color: '#719A5D'}}>
              <Copilot />
              Copilot
            </Flex>
          </Button>
        )}
        <CopilotDrawer
          open={showDrawer}
          onCancel={() => {
            setShowDrawer(false);
          }}
        />
        <ControlCenterMenu setProduct={setProduct} product={product} />
      </Flex>
    </Flex>
  );
};

export default MainHeader;
